"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRELOAD_IMAGES = exports.IS_MOBILE = exports.TRACK_EVENT_CONFIG = exports.MOVE_TYPE = exports.OPERATION_POSITION = exports.LINKS = exports.PRIVATE_MD5_KEY = exports.ERROR_CODE = exports.PROCESS_STATUS = exports.DEFAULT_SHARE_CONFIG = exports.pagePathConfig = exports.DCHN_PATH = exports.ROOT_URL = exports.VIRTUAL_KEYBOARD_ENV = exports.PROD_KEY = exports.VIRTUAL_KEYBOARD_CONFIG = exports.isOnline = exports.isPre = undefined;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

var isPre = exports.isPre = process.env.WEBX_ENV === 'preline';
var isOnline = exports.isOnline = process.env.WEBX_ENV === 'online';
var VIRTUAL_KEYBOARD_CONFIG = exports.VIRTUAL_KEYBOARD_CONFIG = {
  // appId: 'FFFF0N0N0000000099E6'
  appId: '1001',
  sceneId: '100101'
};
var PROD_KEY = exports.PROD_KEY = 'wyc-channel-gift'; // export const VIRTUAL_KEYBOARD_ENV = isOnline ? 'CN' : isPre ? 'release' : 'test'

var VIRTUAL_KEYBOARD_ENV = exports.VIRTUAL_KEYBOARD_ENV = 'CN';
console.log('VIRTUAL_KEYBOARD_ENV', VIRTUAL_KEYBOARD_ENV);
var ROOT_URL = exports.ROOT_URL = isOnline ? 'https://page.udache.com/webx/channel' : 'http://webappstatic.intra.xiaojukeji.com/webx/channel-gift-ws/channel-gift';
var DCHN_PATH = exports.DCHN_PATH = isOnline ? 'https://v.didi.cn/p/' : isPre ? 'https://vstage-pre.intra.xiaojukeji.com/p/' : 'http://vstage-test.intra.xiaojukeji.com/p/';
var pagePathConfig = exports.pagePathConfig = {
  channelGiftUrl: "".concat(ROOT_URL, "/index.html"),
  channelGiftPath: 'pages/index/index'
};
var DEFAULT_SHARE_CONFIG = exports.DEFAULT_SHARE_CONFIG = {
  title: '滴滴出行',
  desc: '滴滴一下，美好出行',
  img_url: 'https://dpubstatic.udache.com/static/dpubimg/ecd95d5f-73cb-4b57-b11b-7280931a6f91.png',
  card_content: '滴滴一下，美好出行',
  icon: 'https://dpubstatic.udache.com/static/dpubimg/ecd95d5f-73cb-4b57-b11b-7280931a6f91.png'
};
var PROCESS_STATUS = exports.PROCESS_STATUS = {
  PREPARE: 1,
  RESULT: 2,
  SHARE: 3,
  ERROR: 4
};
var ERROR_CODE = exports.ERROR_CODE = {
  OK: 0,
  FAIL_TO_GET_DETAIL: 811006,
  // 获取礼包活动详情失败
  FAIL_TO_GET_CONTENT: 811007,
  // 获取已领取礼包内容失败
  FAIL_TO_GET_STATUS: 811008,
  // 获取礼包领取状态失败
  FAIL_TO_GET_ACTIVITY_INFO: 811009,
  // 获取礼包活动失败
  FAIL_TO_RECEIVE: 811010,
  // 开礼包失败
  OFF_TARGET: 811011 // 未命中活动

};
var PRIVATE_MD5_KEY = exports.PRIVATE_MD5_KEY = 'uKYU6DeGoUG0Nju6';
var LINKS = exports.LINKS = {
  WELFARE_CENTER: 'https://page.udache.com/activity/apps/welfare-center/homepage.html#/index',
  DEEP_LINK: 'https://page.udache.com/dpub-template/download-app/index.html?s=md&OneTravel://dache_anycar/entrance',
  POSTER_BACKGROUND: isOnline ? 'https://dpubstatic.udache.com/static/dpubimg/298491d8-a706-4c87-ab3b-4ad48636ed0b.png' : 'https://dpubstatic.udache.com/static/dpubimg/298491d8-a706-4c87-ab3b-4ad48636ed0b.png'
};
var OPERATION_POSITION = exports.OPERATION_POSITION = {
  receiveSuccessBtn: {
    id: 'c659'
  },
  receiveErrorBtn: {
    id: 'c660'
  }
};
var MOVE_TYPE = exports.MOVE_TYPE = {
  normal: 'normal',
  detailed: 'detailed'
};
var TRACK_EVENT_CONFIG = exports.TRACK_EVENT_CONFIG = {
  preparePageShow: {
    eventId: 'wyc_channelreward_get_sw',
    desc: '渠道礼包—领取页面展现'
  },
  telInputFocus: {
    eventId: 'wyc_channelreward_getel_ck',
    desc: '渠道礼包—领取页面—手机号输入点击'
  },
  receiveCouponClick: {
    eventId: 'wyc_channelreward_get_ck',
    desc: '渠道礼包—领取页面—券领取点击'
  },
  resultPageShow: {
    eventId: 'wyc_channelreward_getresult_sw',
    desc: '渠道礼包—领取页面—领取结果页面展现'
  },
  resultPageBtnClick: {
    eventId: 'wyc_channelreward_getresultbtn_ck',
    desc: '渠道礼包—领取页面—领取结果页面按钮点击'
  },
  resultPageCouponClick: {
    eventId: 'wyc_channelreward_getresultbatch_ck',
    desc: '渠道礼包—领取页面—领取结果页面—券点击'
  },
  ruleModalShow: {
    eventId: 'wyc_channelreward_rule_ck',
    desc: '渠道礼包—规则点击'
  },
  makePhoneCall: {
    eventId: 'wyc_channelreward_tel_ck',
    desc: '渠道礼包—呼叫电话点击'
  },
  posterPageShow: {
    eventId: 'wyc_channelreward_share_sw',
    desc: '渠道礼包—分享二维码展现'
  },
  firstNumberTypeIn: {
    eventId: 'wyc_channelreward_firstnum_typ',
    desc: '渠道礼包—输入手机号第一个数字'
  },
  lastNumberTypeIn: {
    eventId: 'wyc_channelreward_lastnum_typ',
    desc: '渠道礼包—输入手机号最后一个数字'
  },
  pollingScanTime: {
    eventId: 'wyc_channelreward_get_time_bt',
    desc: '渠道礼包—落地页曝光时长'
  },
  launchAppClick: {
    eventId: 'wyc_channelreward_diaoqi_bt',
    desc: '渠道礼包-落地页调端'
  },
  launchAppSuccess: {
    eventId: 'wyc_channelreward_diaoqi_success_bt',
    desc: '渠道礼包-落地页调端“成功”(落地页被覆盖)'
  },
  beforeLoad: {
    eventId: 'wyc_channelreward_beforeload_sw',
    desc: '渠道礼包-页面加载前展示'
  },
  beforelGetResult: {
    eventId: 'wyc_channelreward_beforelgetresult_sw',
    desc: '渠道礼包-触发领取'
  }
};
var IS_MOBILE = exports.IS_MOBILE = __isServerRender__ ? true : window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
var PRELOAD_IMAGES = exports.PRELOAD_IMAGES = ['https://dpubstatic.udache.com/static/dpubimg/20eb575c-935d-4187-9f1d-0066c5e15b22.png', // 红包封面
'https://dpubstatic.udache.com/static/dpubimg/8121988a-4ae7-4fb8-aed5-d6aae5350bf6.png', // 红包封面顶部title
'https://dpubstatic.udache.com/static/dpubimg/a320e8d0-b44b-472b-a026-44425c83cee5.png' // 领取按钮
];